<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentAmounts /> 
</template>

<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentAmounts from '@/components/worker/dashboard/modules/report/payments/ContentAmounts.vue'

export default 
{
  name: 'Amounts',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentAmounts
  }
}
</script>

<style>


</style>